const euRestrictions = {
    checkCountry: function( detectedValues ) {
        return themeObject.euRestrictions.restrictedCountries.includes( detectedValues.country_name );
    },

    updateNotification: function() {
        themeObject.soldOutStockElements.forEach( element => {
            element.classList.add('hidden');
        });
        
        themeObject.notAvailableMessageElements.forEach( element => {
            element.classList.replace( 'hidden', 'visible' );
        });
    },

    updateBadges: function() {
        themeObject.soldOutBadges.forEach( badge => {
            badge.classList.add( 'hidden' );
        });

        themeObject.notAvailableBadges.forEach( badge => {
            badge.classList.replace( 'hidden', 'visible' );
        });
    },

    hideButton: function() { 
        themeObject.klaviyoBtn.forEach( trigger => {
            trigger.classList.replace( 'visible', 'hidden' );
        });

        themeObject.checkoutBtn.forEach( btn => {
            btn.classList.add( 'hidden' );
        });

        themeObject.addToCartBtn.forEach( btn => {
            btn.classList.add( 'hidden' );
        });

        themeObject.quickAddBtn.forEach( btn => {
            btn.classList.add( 'hidden' );
        });
    },

    hideVariantSelector: function() {
        const variantSelectors = document.querySelectorAll( '.product__variant-selector' );
        variantSelectors.forEach( selector => {
            selector.classList.add( 'hidden' );
        });
    },

    showButton: function() {
        themeObject.selectors.euRedirectBtn.forEach( btn => {
            btn.classList.replace( 'hidden', 'visible' );
        });
    },

    hideInventoryAlerts: function() {
        themeObject.selectors.inventoryAlerts.forEach( inventoryAlerts => {
            inventoryAlerts.classList.add( 'hidden' );
        });
    }
};

document.addEventListener( 'DOMContentLoaded', () => {
    themeObject.fetchLocalization().then( data => {
        if ( euRestrictions.checkCountry( data.detected_values ) ) {
            euRestrictions.updateNotification();
            euRestrictions.updateBadges();
            euRestrictions.hideButton();
            euRestrictions.hideVariantSelector();
            euRestrictions.showButton();
            euRestrictions.hideInventoryAlerts();
        }
    });
});
